(function () {

  'use strict';

  function pxModalDialog() {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        titleIcon: '=',            // string
        titleText: '=',            // string
        hideCloseButton: '=',      // boolean
        confirmButtonText: '=',    // string
        cancelButtonText: '=',     // string
        disableConfirmButton: '=', // boolean
        disableCancelButton: '=',  // boolean
        confirmButtonSpinner: '=', // boolean
        cancelButtonSpinner: '=',  // boolean
        smallButtons: '=',         // boolean
        largeButtons: '=',         // boolean
        onConfirm: '&',            // function
        onCancel: '&',             // function
        zIndex: '='                // number
      },
      templateUrl: 'app/directives/modal-dialog/modal-dialog.template.html',
      link: function (scope, element, attributes) {

        scope.confirmModalDialog = () => {
          scope.onConfirm();
        };

        scope.cancelModalDialog = () => {
          scope.onCancel();
        };

      }
    };
  }

  pxModalDialog.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxModalDialog', pxModalDialog);

})();
